export default __webpack_public_path__ + "static/media/Foto Expo.416826d0.png";